"use client";

import { Heart, Loader2 } from "lucide-react";

import { useWishlist } from "../hooks/useWishlist";

type WishlistToggleButtonProps = {
  variantId: number | null;
  title: string;
  className?: string;
  filledClassName?: string;
  iconClassName?: string;
  label?: string;
  activeLabel?: string;
  hideIcon?: boolean;
};

export default function WishlistToggleButton({
  variantId,
  title,
  className = "icon-button bg-[var(--color-surface)] text-[var(--color-ink)] ",
  filledClassName = "bg-[rgba(185, 137, 34, 0.14)] text-[var(--color-accent-deep)]",
  iconClassName = "h-4 w-4",
  label,
  activeLabel,
  hideIcon = false,
}: WishlistToggleButtonProps) {
  const {
    isInWishlist,
    isReady,
    isLoading,
    isMutating,
    pendingVariantId,
    toggleItem,
  } = useWishlist();
  const isActive = isInWishlist(variantId);
  const isThisVariantPending =
    typeof variantId === "number" &&
    pendingVariantId === variantId &&
    isMutating;
  const isDisabled = !variantId || variantId <= 0 || !isReady || isLoading || isMutating;

  return (
    <button
      type="button"
      className={[
        className,
        isActive ? filledClassName : "",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label={
        isActive
          ? `أزل ${title} من المفضلة`
          : `أضف ${title} إلى المفضلة`
      }
      aria-pressed={isActive}
      disabled={isDisabled}
      onClick={() => {
        if (!variantId) {
          return;
        }

        void toggleItem(variantId);
      }}
    >
      {isThisVariantPending ? (
        <Loader2 className={`${iconClassName} animate-spin`} />
      ) : (
        <>
          {!hideIcon ? (
            <Heart className={`${iconClassName} ${isActive ? "fill-current" : ""}`} />
          ) : null}
          {label ? <span>{isActive && activeLabel ? activeLabel : label}</span> : null}
        </>
      )}
    </button>
  );
}
